import properties from './props';

const SERVER_DOMAIN = properties.domain;

const API_VERSION = 'v1';

const LOGIN_ENDPOINT = {
  AUTH: `/auth/realms/${properties.realm}/protocol/openid-connect/token`,
};

const CLIENT_GROUP_ENDPOINT = {
  CLIENT_GROUPS: `${SERVER_DOMAIN}/api/${API_VERSION}/trusted-sync/client-groups`,
};

const CLIENT_ENDPOINT = {
  CLIENTS: `${SERVER_DOMAIN}/api/${API_VERSION}/trusted-sync/clients`,
  SCHEDULE_CLIENTS: `${SERVER_DOMAIN}/api/${API_VERSION}/trusted-sync/clients/schedule`,
  UNSCHEDULE_CLIENTS: `${SERVER_DOMAIN}/api/${API_VERSION}/trusted-sync/clients/unschedule`,
};

const DEPARTMENT_ENDPOINT = {
  DEPARTMENT: `${SERVER_DOMAIN}/api/${API_VERSION}/trusted-sync/trusted-driver/department-clients`,
};

const TRUSTED_DRIVER_ENDPOINT = {
  CLIENTS: `${SERVER_DOMAIN}/api/${API_VERSION}/trusted-sync/trusted-driver/clients`,
  DEPARTMENT_CLIENTS: `${SERVER_DOMAIN}/api/${API_VERSION}/trusted-sync/trusted-driver/department-clients`,
  COURT_CLIENTS: `${SERVER_DOMAIN}/api/${API_VERSION}/trusted-sync/trusted-driver/court-clients`,
  CITATIONS: `${SERVER_DOMAIN}/api/${API_VERSION}/trusted-sync/trusted-driver/citations`,
};

const DATA_MAP_ENDPOINT = {
  DATA_MAPS: `${SERVER_DOMAIN}/api/${API_VERSION}/trusted-sync/data-maps`,
  DATA_MAPS_SOURCE_FIELDS: `${SERVER_DOMAIN}/api/${API_VERSION}/trusted-sync/data-maps/source/fields`,
  DATA_MAPS_SOURCE_DATA: `${SERVER_DOMAIN}/api/${API_VERSION}/trusted-sync/data-maps/source/data`,
};

const DATA_ENDPOINT = {
  PREVIEW: `${SERVER_DOMAIN}/api/${API_VERSION}/trusted-sync/data`,
};

const INCIDENT_ENDPOINT = {
  INCIDENTS: `${SERVER_DOMAIN}/api/${API_VERSION}/trusted-sync/trusted-driver/incidents`,
};


const SCRIPT_ENDPOINT = {
  SCRIPTS: `${SERVER_DOMAIN}/api/${API_VERSION}/trusted-sync/scripts`,
};

const TRANSFORMER_SCRIPT_ENDPOINT = {
  SCRIPTS: `${SERVER_DOMAIN}/api/${API_VERSION}/trusted-sync/transformer-scripts`,
  TEST: `${SERVER_DOMAIN}/api/${API_VERSION}/trusted-sync/transformer-scripts/test`,
};

const COMPONENT_MAP_ENDPOINT = {
  COMPONENT_MAP: `${SERVER_DOMAIN}/api/${API_VERSION}/trusted-sync/component-maps`
}

const USER_ENDPOINT = {
  USERS: `${SERVER_DOMAIN}/api/${API_VERSION}/trusted-sync/users`,
};

const TRANSMISSION_LOGS_ENDPOINT = {
  LOGS: `${SERVER_DOMAIN}/api/${API_VERSION}/trusted-sync/logs/transmission`,
};

const CLIENT_ID = properties.clientId;
const CLIENT_SECRET = properties.clientSecret;
const AUTH_GRANT_TYPE = "password";
const REFRESH_GRANT_TYPE = "refresh_token";

export {
  AUTH_GRANT_TYPE,
  CLIENT_GROUP_ENDPOINT,
  CLIENT_ENDPOINT,
  CLIENT_ID,
  CLIENT_SECRET,
  COMPONENT_MAP_ENDPOINT,
  DATA_ENDPOINT,
  DATA_MAP_ENDPOINT,
  DEPARTMENT_ENDPOINT,
  INCIDENT_ENDPOINT,
  LOGIN_ENDPOINT,
  REFRESH_GRANT_TYPE,
  SCRIPT_ENDPOINT,
  SERVER_DOMAIN,
  USER_ENDPOINT,
  TRANSFORMER_SCRIPT_ENDPOINT,
  TRANSMISSION_LOGS_ENDPOINT,
  TRUSTED_DRIVER_ENDPOINT
}